import { KeyboardDatePicker } from '@material-ui/pickers';
import React from 'react';

const CustomDateField = ({ field, form, ...other }) => {
  return (
    <KeyboardDatePicker
      inputVariant="filled"
      emptyLabel=""
      format="DD/MM/YYYY"
      InputLabelProps={{ shrink: true }}
      fullWidth
      clearable={false}
      name={field.name}
      value={field.value || ''}
      onBlur={() => form.setFieldTouched(field.name)}
      onChange={date => {
        form.setFieldTouched(field.name)
        form.setFieldValue(field.name, date?.format());
      }}
      error={Boolean(form.errors[field.name]) && form.touched[field.name]}
      helperText={form.touched[field.name] && form.errors[field.name]}
      invalidDateMessage="Informe uma data válida"
      invalidLabel=""
      maxDateMessage="Informe uma data válida"
      minDateMessage="Informe uma data válida"
      {...other}
    />
  );
};

export default CustomDateField;
